import {Component, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Store} from '@ngrx/store';
import {UntypedFormGroup} from '@angular/forms';
import {
  FormularzUszkodzenService
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz-uszkodzen.service';
import {NavigationService} from '../../../../../../../shared/services/navigation/navigation.service';
import {ActivatedRoute} from '@angular/router';
import {LokalizacjaUszkodzenia} from '../../../../../../../shared/model/uszkodzenia/lokalizacja-uszkodzenia';
import {SlownikService} from '../../../../../../../shared/services/slownik/slownik.service';
import {BaseLokalizacjaUszkodzenComponent} from '../base-lokalizacja-uszkodzen.component';
import {SlownikUszkodzen} from '../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';
import {
  ParametryPowierzchni,
  ParametryZbioruUszkodzen
} from '../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {
  UszkodzeniaWLokalizacjiComponent
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/lokalizacja/uszkodzenia-w-lokalizacji.component';

@Component({
  selector: 'app-ogrodzenia',
  templateUrl: './ogrodzenia.component.html'
})

export class OgrodzeniaComponent extends BaseLokalizacjaUszkodzenComponent implements OnInit, OnDestroy {

  @ViewChildren(UszkodzeniaWLokalizacjiComponent) uszkodzenia!: QueryList<UszkodzeniaWLokalizacjiComponent>;

  constructor(route: ActivatedRoute, store: Store, navigation: NavigationService,
              formularzUszkodzenService: FormularzUszkodzenService,
              slownikService: SlownikService) {
    super(route, store, navigation, formularzUszkodzenService, slownikService)
  }

  get slownikUszkodzen(): SlownikUszkodzen[] {
    return [SlownikUszkodzen.OGRODZENIE_DREWNO, SlownikUszkodzen.OGRODZENIE_SIATKA, SlownikUszkodzen.OGRODZENIE_ZELBETON,
      SlownikUszkodzen.OGRODZENIE_PANELE, SlownikUszkodzen.SLUPKI_OGRODZENIOWE, SlownikUszkodzen.BRAMA_FURTKA]
  }

  get lokalizacjaUszkodzen(): LokalizacjaUszkodzenia {
    return LokalizacjaUszkodzenia.OGRODZENIA;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  iniciujFormularz(): void {
    if (this.czyDataRemontuWymagana) {
      this.formularzLokalizacjiUszkodzenia = new UntypedFormGroup({
        dataRemontu: this.getFormControlWithDateValidation(null)
      })
    }
  }

  zapiszUszkodzeniazPodformularzy(): void {
    const parametry = {} as ParametryZbioruUszkodzen
    if (this.czyDataRemontuWymagana) {
      parametry.dataRemontu = this.formularzLokalizacjiUszkodzenia.controls.dataRemontu.value
    }
    const uszkodzenia = this.uszkodzenia
      .filter((element) => element.wszystkieWartosciWypelnione())
      .map((element) => {
        const parametryUszkodzenia = {} as ParametryPowierzchni
        parametryUszkodzenia.szerokosc = element.wartoscFormularza(element.SZEROKOSC_USZKODZENIA_FORM_FIELD);
        parametryUszkodzenia.wysokosc = element.wartoscFormularza(element.WYSOKOSC_USZKODZENIA_FORM_FIELD);
        return element.utworzObiektUszkodzenia(parametryUszkodzenia)
      });
    this.utworzLubAktualizujZbiorUszkodzen(parametry, uszkodzenia);
  }
}
